import { useState } from "react";
import { useTranslation } from "react-i18next";
import externalPageApi from "api/externalPage";
import { useParams, useNavigate } from "react-router-dom";
import useNotify from "hooks/useNotify";

const useInviteAssignees = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { notifyError } = useNotify();
  const { token } = useParams();

  const url = window.location.href;
  const emailParam = decodeURI(url).split("email=")[1];

  const [isLoading, setIsLoading] = useState({ accept: false, reject: false });
  const [successMsg, setSuccessMsg] = useState("");
  const [isAccept, setIsAccept] = useState();

  const onInviteAssignee = async (data, isAccept) => {
    try {
      setIsAccept(isAccept);
      setIsLoading(
        isAccept
          ? { accept: true, reject: false }
          : { accept: false, reject: true }
      );

      const payload = {
        isAcceptInvitation: isAccept,
        token,
        email: emailParam ? decodeURIComponent(emailParam) : data.email,
      };

      await externalPageApi.respondPendingAssignee(payload);
      setSuccessMsg(
        isAccept ? t("inviteAssigneeAcceptMsg") : t("inviteAssigneeRejectMsg")
      );
    } catch (err) {
      console.error(err);
      notifyError(
        err?.response?.data?.message ?? err?.message ?? "Something went wrong!"
      );
    } finally {
      setIsLoading({ accept: false, reject: false });
    }
  };

  return {
    navigate,
    isLoading,
    emailParam,
    onInviteAssignee,
    successMsg,
    isAccept,
  };
};

export default useInviteAssignees;
